import Loadable from 'react-loadable';
import { LCLoading } from 'control/loading';
import { AuthorizedRouter } from 'acl';
import { Route, Switch } from 'react-router-dom';
import React from 'react';

const NoticeManage = Loadable({
    loader: () => import('./NoticeManage'),
    loading: LCLoading,
  });


const NoticeDetail = Loadable({
    loader: () => import('./NoticeDetail'),
    loading: LCLoading,
  });

const Addnotice = Loadable({
    loader: () => import('./Addnotice'),
    loading: LCLoading,
  });


  const NoticeManagementRoute = ({ match }) => {

    return (
      <Switch>
        <Route exact path={`${match.path}`} component={NoticeManage} />
        <Route exact path={`${match.path}/noticeDetail/:messageUid`} component={NoticeDetail} />
        <Route exact path={`${match.path}/addnotice`} component={Addnotice} />
      </Switch>
    );
  }
  export { NoticeManagementRoute };
  